import React from 'react';
import { Grid, Stack } from '@mui/material';
import BieExecutiveCardsPanel from './BieExecutiveCardsPanel';
import BieScenarioRecommendationPanel from './BieScenarioRecommendationPanel';
import ObjectiveGapGrid from './ObjectiveGapGrid';

type Props = { scenarioCode?: string; summary?: any; objectiveGaps?: any[]; constraints?: any[]; loading?: boolean; onApplyScenario?: () => void };

class BieExecutiveDecisionWorkbenchPanel extends React.PureComponent<Props> {
  render() {
    return (
      <Stack spacing={3}>
        <BieExecutiveCardsPanel summary={this.props.summary} />
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, lg: 8 }}>
            <ObjectiveGapGrid rows={this.props.objectiveGaps || []} loading={this.props.loading} />
          </Grid>
          <Grid size={{ xs: 12, lg: 4 }}>
            <BieScenarioRecommendationPanel
              scenarioCode={this.props.scenarioCode}
              summary={this.props.summary}
              objectiveGaps={this.props.objectiveGaps || []}
              constraints={this.props.constraints || []}
              onApplyScenario={this.props.onApplyScenario}
            />
          </Grid>
        </Grid>
      </Stack>
    );
  }
}
export default BieExecutiveDecisionWorkbenchPanel;
